/**
 * Created by hernanherreros on 2019-05-27
 */

import * as React from 'react'
import { getSteps } from './routes'
import { getCongressAlias, getCongressSlug } from '../config/congress.config'

const pathTemplate = '/:congressSlug/wizard/:token/:step'
const sharingPathTemplate = '/:congressSlug/sharing'
const visitorPathTemplate = '/:congressSlug'

export const getNextWizardPath = (token: string, congressSlug: string, currentStep?: string) => {
  const steps = getSteps(congressSlug)

  const currentIndex = currentStep ? steps.indexOf(currentStep) : -1
  const nextIndex = currentIndex + 1

  const step =  nextIndex < steps.length ? steps[nextIndex] : ''

  return pathTemplate
    .replace(':congressSlug', getCongressAlias(congressSlug))
    .replace(':token', token)
    .replace(':step', step.toLowerCase())
}

export const getSharingPath = (congressSlug: string) => {
  return sharingPathTemplate
    .replace(':congressSlug', getCongressAlias(congressSlug))
}

export const getVisitorLink = (congressSlug: string) => {
  return visitorPathTemplate
    .replace(':congressSlug', getCongressAlias(congressSlug))
}